export class UserZone {
    userId?: number;
    customerId: number;
    regionId: number;
    cityDesc: string;
}
